export default __webpack_public_path__ + "static/media/bg-login-medico.c1a3d8cd.png";